import React from "react";
import { withRouter } from "react-router";
import { PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import { MessageUtil } from '../../../../../util/MessageUtil';     
import { LoadUtil } from "../../../../../framework/util/LoadUtil"; 
import { EnvConstants } from "../../../../../EnvConstants";
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import confirm from 'antd/lib/modal/confirm';
 
class DatosSolicitantesSection extends BasePage {
    renderPage(pageApi) {
     
    const getForm_datos_soli = () => pageApi.getComponent('form_datos_soli');
 
    const form_datos_soli = {
      layout: 'vertical',
        load:{
        validation: () => pageApi.getParamId() != null, 
        queryId: 815, 
        params: { id_doc: pageApi.getParamId()  
        },
        fnOk: (resp) => {
          getForm_datos_soli().setFieldData("ruc", resp?.dataObject?.ruc);
          getForm_datos_soli().setFieldData("id_forma_pago", resp?.dataObject?.id_forma_pago);
        },
        },
        save: { 
        queryId: 814,  
        params: { est_tab : 2, id_user: UserUtil.getUserId() }, 
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {  
            const id_doc = resp.dataObject?.id_doc;    
            const est_tab_actual = resp.dataObject?.est_tab;    

            if(est_tab_actual == 2){
              this.props.history.push(`/cotizaciones/cotizaciones/2/${id_doc}`)
            }
         
            this.props.cambiarTabPanel("2",id_doc);  
            return MessageUtil(
              "success",
              "Exito!",
              "Se ha habilitado Datos de Analisis"
            ); 
          },
        
        },
      title: '',
      collapsible: true,
      fields:[
          {
              label: '  ',
              fields: [
                {type: 'hidden', name: 'id_doc'}, 
                {
                type: "select",
                name: "id_empresa",
                label: "Empresa Solicitante",
                column: 4,
                load: { 
                  queryId: 861, 
                  params: {
                    id_user: UserUtil.getUserId()
                  },
                  fnOk: (resp) => {
                    const arr = resp.dataList || []
                    
                    if (arr.length > 0) {
                      getForm_datos_soli().setData({
                        ...getForm_datos_soli().getData(),
                        id_empresa: arr[0].value
                      })
                    }
                  }
                },
                search: true,
                required: true,
                allowClear: true,
                onChange: (value, values) => {
                    let ruc = getForm_datos_soli()
                    ?.getFieldApi("id_empresa")
                    ?.getSelectedItem()?.ruc;

                    let condicion_pago = getForm_datos_soli()
                    ?.getFieldApi("id_empresa")
                    ?.getSelectedItem()?.condicion_pago;
                    
                    getForm_datos_soli().setFieldData("ruc", ruc);
                    getForm_datos_soli().setFieldData("id_forma_pago",condicion_pago); 
                }, 
                }, 
                { name: "ruc", label: "Ruc", column: 2, readOnly: true }, 
                {
                type: "select", name: "id_solicitante", label: "Usuario Solicitante", column: 3, load: { queryId: 127, fnOk: (resp) => {
                  if (resp.dataList?.length) {
                    const findUser = resp.dataList.find(el => el.id_user == UserUtil.getUserId());
                    
                    if (findUser) {
                      getForm_datos_soli().setData({
                        ...getForm_datos_soli().getData(),
                        id_solicitante: findUser.value
                      })
                    }

                  }
                } }, search: true,
                parents: [
                    { name: "id_empresa", paramName: "id_empresa", required: true },
                    // { name: "id_user", paramName: UserUtil.getUserId()  , required: true },
                ],
                }, 
                {type: 'select', name:'id_servicio', label:'Tipo Servicio', column: 2,value: 9, load: { queryId: 128 ,}, search: true},
                {type: 'select', name:'id_moneda', label:'Moneda', column: 2,value: 1, load: { queryId: 77 }, search: true},
                { name: "id_forma_pago", label: "Condicion Pago", column: 2, readOnly: true }, 
                {type: 'select', name:'id_vigencia_cotizacion', label:'Vigencia de Cotizacion', column: 2,value: 1, load: { queryId: 145 }, search: true},
                {type: 'select', name:'id_tipo_servicio', label:'Tipo Documento', column: 2,value: 2, load: { queryId: 147 }, search: true}, 
              ]   
          }
      ],
      onComponentLoad : (formApi, pageApi) =>{
          if (pageApi.getPageMode() !== PAGE_MODE.NEW)
              formApi.load();
      } 
    }
 
    const barButtonFooter = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN, link: '/cotizaciones/cotizaciones-admin', alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE, label: 'Guardar y Continuar',
                onClick: () => {
              
                    let id_empresa = getForm_datos_soli()?.getData().id_empresa;             
                    let id_solicitante = getForm_datos_soli()?.getData().id_solicitante;      
                    let id_moneda_cambiar = getForm_datos_soli()?.getData().id_moneda;      
                    let id_monedaactual = getForm_datos_soli()?.getData().id_monedaactual;      
                    if(id_monedaactual != undefined){
                      console.log(id_monedaactual, id_moneda_cambiar)
                      if(id_monedaactual != id_moneda_cambiar){
                        confirm({
                          title: 'Desea Cambiar el tipo moneda?',
                          icon: <ExclamationCircleOutlined />,
                          content: 'Se borraran todos los datos a partir de Datos de Analisis',
                          onOk() {
                              getForm_datos_soli().save()  
                            },
                            onCancel() {
                            },
                          });
                      } else {
                        getForm_datos_soli().save()  
                      }
                    }
                    else if(id_empresa === undefined){ 
                        return MessageUtil('warning','Alerta!','Debe Seleccionar Empresa');
                    }
                    else if (id_solicitante === null){ 
                        return MessageUtil('warning','Alerta!','Debe Seleccionar Solicitante');
                    }
                     else { 
                          getForm_datos_soli().save()
                     } 
                }
            }, 
        ]
    }
  
    return (
      <>
        <FormFw
          name="form_datos_soli"
          getParentApi={pageApi.getApi}
          config={form_datos_soli} 
        /> 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter} 
        /> 
      </>
    ); 
  }
} 
export default DatosSolicitantesSection